import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getReservationLanguages } from 'modules/_common/api';

export const useQueryReservationLanguages = (enabled: boolean | undefined) => {
  const { isLoading, error, data } = useQuery(
    QUERY_KEYS.UNITS_RESERVATION_LANGUAGES,
    getReservationLanguages,
    {
      ...getCacheSettings(),
      enabled: enabled ?? false,
    },
  );

  return {
    loading: isLoading,
    error: error,
    reservationLanguages: data?.items,
  };
};
